import List from 'src/storage/messageList';

export class TreatmentModel extends List {
  id = 'treatment';
  defaultState = () => ({
    files: [],
    media: [],
    clinics: [],
    medicines: [this.defaultMedicines()],
    recommendations: [this.defaultRecommendations()],
    current: 'recent'
  });
  defaultMedicines = () => ({
    name: '',
    doze: 1,
    days: 1,
    period: 'any',
    times: []
  });
  defaultRecommendations = () => ({
    type: '',
    detail: ''
  });
  refreshOnInit = false;
  refreshOnSubscribe = false;
  sortBy = {
    key: 'date',
    desc: true
  };
  apiConfig = {
    refresh: {
      url: 'treatment/refresh',
      validation: {
        partnerId: 'userId',
        skip: 'skip',
        limit: 'limit'
      },
      cancellable: true
    },
    list: {
      url: 'treatment/list',
      validation: {
        partnerId: 'userId',
        skip: 'skip',
        limit: 'limit'
      },
      cancellable: true
    },
    search: {
      url: 'treatment/search',
      validation: {
        partnerId: 'userId',
        skip: 'skip',
        limit: 'limit'
      },
      cancellable: true
    },
    create: {
      url: 'treatment/create',
      validation: {
        partnerId: 'userId',
        medicines: 'medicines',
        recommendations: 'recommendations',
        diagnosis: 'diagnosis',
        files: 'files',
        description: 'description',
        note: 'note',
        recommendation: 'recommendation',
        nextUpdateAmount: 'nextUpdateAmount',
        nextUpdateUnit: 'nextUpdateUnit'
      },
      cancellable: true
    },
    remove: {
      url: 'treatment/remove',
      validation: {
        id: 'number'
      }
    }
  };

  _events = {
    openContact: 'onOpenContact',
    profile: 'handleProfile',
    'foxsocket:message:treatment': 'onMessage',
    'foxsocket:message:treatment_update': 'onTreatmentUpdateWS',
    'foxsocket:message:treatment_remove': 'onTreatmentRemoveWS',
    treatment_remove: 'onTreatmentRemove'
  };

  filterItem = this.onFilterOtherItem;

  onTreatmentUpdateWS = ({ data }) => {
    let item = this.mapItem(data);
    this.updateItem(item, { listId: this.state.partnerId + ':recent' });
    this.updateItem(item, { listId: this.state.partnerId + ':search' });
  };

  onTreatmentRemoveWS = ({ data: id }) => {
    this.onTreatmentRemove(id);
  };

  onTreatmentRemove = (id) => {
    this.removeItem(id, { listId: this.state.partnerId + ':recent' });
    this.removeItem(id, { listId: this.state.partnerId + ':search' });
  };

  handleProfile = (profile) => {
    this.setState({ user: profile });
  };

  listParams(loadMore) {
    let req = {
      partnerId: this.state.partnerId,
      skip: 0,
      limit: this.listLimit,
      doctorIds: this.doctorIds()
    };

    let query = this.listInput('search');
    if (query.length > 0) {
      req.query = query;
    }
    if (loadMore) {
      let skip = this.items().length;
      if (skip < this.listLimit) return null;
      req.skip = skip;
    }
    return req;
  }

  create = (cb) => {
    let req = {
      messageId: this.state.messageId,
      treatmentId: this.state.treatmentId,
      partnerId: this.state.editItem?.partnerId || this.state.partnerId,
      medicines: this.state.medicines,
      recommendations: this.state.recommendations,
      diagnosis: this.state.diagnosis,
      note: this.state.note,
      files: [],
      description: this.state.description,
      recommendation: this.state.recommendation,
      nextUpdateAmount: this.state.nextUpdateFlg ? this.state.nextUpdateAmount : 0,
      nextUpdateUnit: this.state.nextUpdateFlg ? this.state.nextUpdateUnit : '',
      clinicId: this.state.user.clinicIds?.length ? this.state.user.clinicIds[0] : 0,
      hospitalId: this.state.hospitalId
    };
    req.media = this.state.media.map(({ file, ...item }) => {
      if (file) {
        req.haveFiles = true;
        req[item.id] = file;
        return item;
      }
      return item;
    });
    this.api('create', req, (err, data, success) => {
      cb(err, data, success);
      if (success) {
        this.resetAddTreatment();
        data = this.mapItem(data);
        this.filterItem(data);
      }
    });
  };

  resetAddTreatment = (editItem) => {
    this.resetApi();
    let edit = (editItem && editItem.data) || {};
    this.setState({
      messageId: editItem?.id || 0,
      treatmentId: editItem?.treatmentId || edit.treatmentId || 0,
      medicines: edit.medicines || [this.defaultMedicines()],
      recommendation: edit.recommendation || '',
      recommendations: edit.recommendations || [this.defaultRecommendations()],
      diagnosis: edit.diagnosis || '',
      description: edit.description || '',
      files: [],
      media: editItem?.media || [],
      note: edit.note || '',
      nextUpdateAmount: edit.nextUpdateAmount || 0,
      nextUpdateUnit: edit.nextUpdateUnit || 'days',
      nextUpdateFlg: edit.nextUpdateFlg || true,
      clinicId: editItem?.clinicId || 0,
      hospitalId: editItem?.hospitalId,
      editItem: editItem || null,
      mediaId: Date.now()
    });
  };

  addMoreMedicine = () => {
    const medicines = this.input('medicines');
    medicines.push(this.defaultMedicines());
    this.handleChange('medicines', [...medicines]);
  };

  delMedicine = (delIds) => {
    const medicines = this.input('medicines');
    this.handleChange('medicines', [...medicines.filter((item, i) => delIds.indexOf(i) === -1)]);
  };

  addMoreRecommendation = () => {
    const recommendations = this.input('recommendations');
    recommendations.push(this.defaultRecommendations());
    this.handleChange('recommendations', [...recommendations]);
  };

  delRecommendation = (delIds) => {
    const recommendations = this.input('recommendations');
    this.handleChange('recommendations', [
      ...recommendations.filter((item, i) => delIds.indexOf(i) === -1)
    ]);
  };

  remove = (id, item, cb) => {
    this.emit('treatment_remove', id);
    this.api('remove', { id }, (err, res, success) => {
      if (!success) {
        // TODO - restore item
      }
      cb && cb(err, res, success);
    });
  };
}

const model = new TreatmentModel();
export default model;
